import { render, staticRenderFns } from "./GithubCard.vue?vue&type=template&id=01b76fa8&scoped=true&"
import script from "./GithubCard.vue?vue&type=script&lang=js&"
export * from "./GithubCard.vue?vue&type=script&lang=js&"
import style0 from "./GithubCard.vue?vue&type=style&index=0&id=01b76fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b76fa8",
  null
  
)

export default component.exports